import { useState } from "react";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import isToday from 'dayjs/plugin/isToday'
import Table from "react-bootstrap/Table";
import { OverlayTrigger, ProgressBar } from "react-bootstrap";
import { isThisWeek, isThisMonth } from "date-fns";
import { VistasComentarios } from "./VistaArbol";
import { DeleteTask } from "./VistaArbol";
import { PrioridadIcon } from "../../../components/catalogo/CatalogosTareas";
import { totalMiembros } from "./VistaArbol";
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import MiembrosMap from "../../../components/helpers/MiembrosMap";
import { estatusColor } from "../../../components/catalogo/EstatusTask";

export default function VistaLista({
    options,
    toggleShow
}) {
    dayjs.locale(es);
    dayjs.extend(isToday);

    let data = [
        {
            fecha : "Hoy",
            value: [],
            children: []
        },
        {
            fecha : "Esta semana",
            value: [],
            children: []
        },
        {
            fecha : "Este mes",
            value: [],
            children: []
        },
        {
            fecha : "Próximo",
            value: [],
            children: []
        }
    ];
    /**
     * @property inicio_proyectado
     * @property termino_proyectado
     * @property id_tarea
     * @property archivos_adjuntos
     */


    options && options.forEach( (t) => {
        let date = t.termino_proyectado.slice(0,10);

            if (dayjs(date).isToday()){
                data[0].value.push(t.id_tarea);
                data[0].children.push(t);
            } else if (isThisWeek(date)){
                data[1].value.push(t.id_tarea);
                 data[1].children.push(t);
            } else if (isThisMonth(date)){
                data[2].value.push(t.id_tarea);
                data[2].children.push(t);
            } else {
                data[3].value.push(t.id_tarea);
                data[3].children.push(t);
            }


            if (t.children.length > 0){
                t.children.forEach((c) => {
                    let date = c.termino_proyectado.slice(0,10);

                    if (dayjs(date).isToday()){
                        data[0].value.push(c.id_tarea);
                        data[0].children.push(c);
                    } else if (isThisWeek(date)){
                        data[1].value.push(c.id_tarea);
                        data[1].children.push(c);
                    } else if (isThisMonth(date)){
                        data[2].value.push(c.id_tarea);
                        data[2].children.push(c);
                    } else {
                        data[3].value.push(c.id_tarea);
                        data[3].children.push(c);
                    }

                    if (c.children.length > 0){
                        c.children.forEach((s) => {
                            let date = s.termino_proyectado.slice(0,10);

                            if (dayjs(date).isToday()){
                                data[0].value.push(s.id_tarea);
                                data[0].children.push(s);
                            } else if (isThisWeek(date)){
                                data[1].value.push(s.id_tarea);
                                data[1].children.push(s);
                            } else if (isThisMonth(date)){
                                data[2].value.push(s.id_tarea);
                                data[2].children.push(s);
                            } else {
                                data[3].value.push(s.id_tarea);
                                data[3].children.push(s);
                            }

                            if (s.children.length > 0){
                                s.children.forEach((e) => {
                                    let date = e.termino_proyectado.slice(0,10);

                                    if (dayjs(date).isToday()){
                                        data[0].value.push(e.id_tarea);
                                        data[0].children.push(e);
                                    } else if (isThisWeek(date)){
                                        data[1].value.push(e.id_tarea);
                                        data[1].children.push(e);
                                    } else if (isThisMonth(date)){
                                        data[2].value.push(e.id_tarea);
                                        data[2].children.push(e);
                                    } else {
                                        data[3].value.push(e.id_tarea);
                                        data[3].children.push(e);
                                    }
                                })
                            }
                        })
                    }
                })
            }
    })

    // @media (min-width: 992px) {
    // .footer-fixed .wrapper{
    //         padding-botom: none!important;
    //     }
    // }

    return(
        <>
            <style type={"text/css"}>
                {`
                    .rs-badge-independent, .rs-badge-content {
                        font-size: 8px;
                    }
                    
                    .form-check-input{
                        margin-left: 1rem!important;
                    }
                    
                    .dropdown-toggle {
                        padding: 0.5rem!important;
                    }
                    
                    .rotate-arrow {
                        transform : rotate(90deg);
                    }
                    
                 
                `}
            </style>
            <Table id={'lista'} responsive={true} className=" table-row-dashed table-row-gray-300 align-middle gs-0 ">
                <thead>
                    <tr className={"fw-bold text-muted"}>
                        <th width={20}></th>
                        <th width={20}></th>
                        <th width={15}></th>
                        <th className={"text-start"}> TAREAS </th>
                        <th width={150} className={"text-start"}> MIEMBROS </th>
                        <th width={125} className={"text-start"}> INICIO </th>
                        <th width={125} className={"text-start"}> FIN </th>
                        <th width={200} className={"text-start"}> PROGRESO </th>
                        <th width={100} className={"text-start"}></th>
                    </tr>
                </thead>
                <tbody>
                {
                    data && data.map((f) => <ListaTabla key={f.fecha} f={f} toggleShow={toggleShow}></ListaTabla>)
                }
                </tbody>
            </Table>
        </>
    );
}


function ListaTabla ({
    f,
    toggleShow
}){
    const [display, setDisplay] = useState(false);
    const [values, setValues] = useState([])

    function handleCloseList(arr){
        setValues(arr);
        setDisplay(!display);
    }

    return(
        <>
            <tr>
                <td colSpan={5} >
                    <button type={'button'} className={"btn p-0 text-gray-800 ms-3"} style={{fontSize: "1.35rem"}}
                            onClick={() => handleCloseList(f.value)} disabled={f.children.length === 0}>
                            <i className={"bi bi-caret-right-fill text-dark fs-9 " + (!display ? "rotate-arrow" : "") }></i> {f.fecha}
                    </button>
                </td>
            </tr>
            {
                f.children && f.children.map((o) => {
                    return (
                        <tr key={o.id_tarea} className={" " + ((values.includes(o.id_tarea) && display) && "d-none")}>
                            <td className={"ps-3"}>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex flex-column text-center">
                                        {
                                            o.archivos_adjuntos === true && <div>
                                                <TitleTooltip title={"El proyecto contiene archivos adjuntos"} placement={'top'}>
                                                    <i className="ki-solid ki-paper-clip fs-3 text-primary"></i>
                                                </TitleTooltip>
                                            </div>}
                                        {
                                            (o.comentarios && o.comentarios.length > 0) &&
                                            <div className="d-block">
                                                <VistasComentarios comentarios={o.comentarios}></VistasComentarios>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </td>
                            <td >
                                {
                                    o.recordatorio.slice(0, 10) === dayjs().format('YYYY-MM-DD') &&
                                    <TitleTooltip title={"La tarea está por expirar"} placement={'top'}><i className="bi bi-alarm-fill fs-6 text-primary"></i></TitleTooltip>
                                }
                            </td>
                            <td >
                                {
                                    o.prioridad && <PrioridadIcon classB={o.prioridad}></PrioridadIcon>
                                }
                            </td>
                            <td>
                                <div className={'d-flex text-nowrap overflow-hidden fs-6'}>
                                    <div className={"d-flex flex-column"}>
                                        <button type={'button'} onClick={(e) => toggleShow(e, o.id_tarea, o.tarea)}
                                                className="btn btn-link p-0 text-start text-uppercase text-gray-900 text-hover-primary fs-6 fw-semibold"
                                        >
                                            {o.tarea}
                                        </button>
                                        <span className="text-muted fs-6 d-block">{o.objetivo}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="symbol-group symbol-hover">
                                    {
                                        o.miembros && o.miembros.map((m, index) => {
                                            return (index < 4 && <MiembrosMap key={m.usuario} user={m.usuario} avatar={m.avatar}></MiembrosMap>);
                                        })
                                    }
                                    {
                                        o.miembros && o.miembros.length > 4 &&
                                        <OverlayTrigger overlay={totalMiembros(o.miembros)} placement="right"
                                                        delay={{show: 250, hide: 400}}>
                                            <div className={"symbol symbol-30px symbol-circle"}>
                                                <span className={"symbol-label fw-bold fs-8 text-white bg-dark"}>+{o.miembros.length}</span>
                                            </div>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </td>
                            <td>
                                <span className={"fw-semibold d-block mb-1 fs-6 text-capitalize"}>
                                    {dayjs(o.inicio_proyectado.slice(0, 10)).format('MMM DD, YYYY')}
                                </span>
                            </td>
                            <td>
                                <span
                                    className={"fw-semibold d-block mb-1 fs-6 text-capitalize"}>
                                    {dayjs(o.termino_proyectado.slice(0, 10)).format('MMM DD, YYYY')}
                                </span>
                            </td>
                            <td>
                                <TitleTooltip title={'Estatus: ' + o.estatus} placement={'top'}>
                                    <ProgressBar now={o.progreso} label={`${o.progreso}%`} variant={estatusColor(o.estatus)} style={{width: "100%"}}/>
                                </TitleTooltip>
                            </td>
                            <td className={"p-1 text-end"}>
                                <DeleteTask id={o.id_tarea}></DeleteTask>
                            </td>
                        </tr>
                    )
                })
            }
        </>
    );
}



